import CompanyDashboard from "../../../components/admin/all-companies/company-dashboard";

export default function CompanyDashboardPage(){
    return <CompanyDashboard />
}